<template>
  <div class="gray-100 progress rounded-progress-medium position-relative">
    <div
      class="d-flex h-100 position-absolute align-items-center progress-meta pr-3 text-gray-300"
      :style="`right:${100 - middlePercentage}%`"
    >
      <div v-if="middlePercentage">
        Meta atual: {{ middlePercentage }}%
      </div>
    </div>
    <div
      :class="`rounded-progress-medium d-flex align-items-center justify-content-end ${percentage > 0 ? `${classBgPercentage} text-white` : ''} z-index-1`"
      :style="`width:${barWidth}%`"
    >
      <div class="pr-2">
        {{ percentage.toFixed(percentage == 100 || percentage == 0 ? 0 : toFixed) }}%
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        percentage:{
            required:true,
            type:Number
        },
        middlePercentage:{
            required:false,
            type:Number,
            default:0
        },
        classBgPercentage:{
            required:false,
            type:String,
            default:'bg-module'
        },
        toFixed:{
          type: Number,
          default: 0
        }
    },
    computed:{
      barWidth(){
        if(this.percentage <= 0) {
          return 5;
        }else {
          return this.percentage <= 10 ? (this.$vuetify.breakpoint.mobile ? 20 : 10) : this.percentage;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
.rounded-progress-medium {
  border-radius: 13px;
}

.progress {
  height:  25px;
  width: 100%;
  font-size: 20px;
}

.z-index-1 {
 z-index: 1;
}

.progress-meta {
 z-index: 0;
 border-right: 3px dashed #B2B9CB;
}


</style>
